import { Mat, Point, subtract, imshow } from '@techstark/opencv-js'
import LinearSpline from './LinearSpline';

export default class Calibrator {
  static #instance = null;

  static getInstance() {
    if (!Calibrator.#instance) {
      Calibrator.#instance = new Calibrator();
    }
    return Calibrator.#instance;
  }

  constructor() {
    if (Calibrator.#instance) {
      return Calibrator.#instance;
    }
    Calibrator.#instance = this;

    this.version = null;
    this.width = null;
    this.height = null;
    this.sensivity = null;
    this.calibrationMatrix = null;
    this.interpolationMatrix = null;
    this.calibPath = process.env.PUBLIC_URL + "/Settings/Calibration";
    this.percentToKgCM2 = 0.085;
    this.toIntScale = 100;
    this.zeroFrame = new Mat();
    this.damagedSensors = [];
  }

   async Load(info, calibs) {
      const lines = info.split(/\r?\n/);
      if (lines[0].startsWith("V4")) this.version = "V4";
      this.width = Number(lines[1]);
      this.height = Number(lines[2]);
      this.sensivity = Number(lines[3]);
      this.init(calibs);
  };

  // async Load() {
  //   await fetch(`${this.calibPath}/Info.txt`)
  //     .then(response => response.text())
  //     .then(text => {
  //       const lines = text.split(/\r?\n/);
  //       if (lines[0].startsWith("V4")) this.version = "V4";
  //       this.width = Number(lines[1]);
  //       this.height = Number(lines[2]);
  //       this.sensivity = Number(lines[3]);
  //       this.init();
  //     });
  // };

  async init(calibContent) {
    await this.LoadCalibrationMartrix(calibContent);
    this.InitializeInterpolationMatrix();
  }

  async readCalibFiles(files) {
    try {
      const fileContents = await Promise.all(
        files.map(async (file) => {
          const response = await fetch(file);
          if (!response.ok) throw new Error(`Failed to fetch ${file}`);
          return response.text();
        })
      );

      //console.log(fileContents); // Array of file contents
      return fileContents;
    } catch (error) {
      console.error("Error reading files:", error);
    }
  }

  async LoadCalibrationMartrix(calibContent) {
    this.calibrationMatrix = Array.from({ length: this.width }, () =>
      Array.from({ length: this.height }, () => [])
    );

    for (let index = 0; index < calibContent.length; index++) {
      const element = calibContent[index].content;
      const match = calibContent[index].name.match(/[^\\/]+$/)[0];
      const calibFileValue = parseFloat(match.substring(0, match.length));
      this.AddtoCalibrationMatrix(element, calibFileValue);
    }
    this.SortCalibrationMatrixByX();
    console.log('reading calibration matrix finished');
  }

  // async LoadCalibrationMartrix() {
  //   this.calibrationMatrix = Array.from({ length: this.width }, () =>
  //     Array.from({ length: this.height }, () => [])
  //   );

  //   let calibFilesName = [`${this.calibPath}/0.00.cal`, `${this.calibPath}/10.00.cal`, `${this.calibPath}/20.00.cal`, `${this.calibPath}/30.00.cal`, `${this.calibPath}/40.00.cal`,
  //   `${this.calibPath}/50.00.cal`, `${this.calibPath}/60.00.cal`, `${this.calibPath}/70.00.cal`, `${this.calibPath}/80.00.cal`, `${this.calibPath}/90.00.cal`];

  //   const contents = await this.readCalibFiles(calibFilesName);

  //   for (let index = 0; index < contents.length; index++) {
  //     const element = contents[index];
  //     const match = calibFilesName[index].match(/[^\\/]+$/)[0];
  //     const calibFileValue = parseFloat(match.substring(0, match.length));
  //     this.AddtoCalibrationMatrix(element, calibFileValue);
  //   }
  //   this.SortCalibrationMatrixByX();
  //   console.log('reading calibration matrix finished');
  // }

  AddtoCalibrationMatrix(rawString, realVal) {
    const realInt = realVal * this.percentToKgCM2 * this.toIntScale;
    const lines = rawString.split(/\r?\n/);
    for (let h = 0; h < this.height; h++) {
      const line = lines[h];
      let lineValues = new Array(this.width);
      lineValues = line.split('\t');
      for (let w = 0; w < this.width; w++) {
        const ADC_val = parseFloat(lineValues[w])
        this.AddPoint(w, h, ADC_val, realInt);
      }

    }
  }

  AddPoint(x, y, px, py) {
    if (x >= 0 && x < this.width && y >= 0 && y < this.height) {
      this.calibrationMatrix[x][y].push(new Point(px, py));
      //   console.log(`Added PointXY(${px}, ${py}) to (${x}, ${y})`);
    } else {
      console.error("Invalid index for calibrationMatrix.");
    }
  }

  SortCalibrationMatrixByX() {
    for (let h = 0; h < this.height; h++) {
      for (let w = 0; w < this.width; w++) {
        this.calibrationMatrix[w][h].sort(function (a, b) {
          if (a.x > b.x) return 1;
          else if (a.x < b.x) return -1;
          else return 0;
        })
      }
    }
  }

  InitializeInterpolationMatrix() {
    let calibErrorsText = "";
    this.interpolationMatrix = Array.from({ length: this.width }, () => new Array(this.height));
    for (let h = 0; h < this.height; h++) {
      for (let w = 0; w < this.width; w++) {
        let len = this.calibrationMatrix[w][h].length;
        let x = new Array(len);
        let y = new Array(len);
        let xCalib = [], yCalib = [];

        for (let i = 0; i < len; i++) {
          x[i] = this.calibrationMatrix[w][h][i].x;
          y[i] = this.calibrationMatrix[w][h][i].y;
        }

        for (let i = 0; i < len - 1; i++) {
          if (x[i] < x[i + 1]) {
            if (i==0 && x[i]>0) x[0] = 0;
            xCalib.push(x[i]);
            yCalib.push(y[i]);
          }
        }

        if (x[len - 1] > x[len - 2]) {
          xCalib.push(x[len - 1]);
          yCalib.push(y[len - 1]);
        }

        if (xCalib.length < 2) {
          calibErrorsText += `Calibration for pixel(" + ${w} + ", " + ${h} + ") failed!\n`;
          xCalib.push(0);
          yCalib.push(0);
          xCalib.push(1000);
          yCalib.push(10);
        }

        let regresssor = new LinearSpline();
        regresssor.train(xCalib, yCalib);
        this.interpolationMatrix[w][h] = regresssor;
      }
    }
    console.log(calibErrorsText);
    this.RotateMatricesV4();
    this.LoadDamagedSensors();
  }

  async LoadDamagedSensors() {
    const file = `${this.caliPath}/PressureOpt.tx`;
    try {
      const response = await fetch(file);
      const contentType = response.headers.get("content-type") || "";
      const isTextFile = contentType.includes("text/plain");
      if (response.ok && isTextFile) {
        let damegedstr = await response.text();
        let lines = damegedstr.split(/\r?\n/);
        lines.forEach(line => {
          if (line.trim() === '') return;
          let elements = line.split(';');
          if (elements.length >= 2) {
            let damagedPoint = new Point(elements[0], elements[1]);
            this.damagedSensors.push(damagedPoint);
          }
        });
      }

    } catch (error) {

    }

  }

  RotateMatricesV4() {
    let tempIM = Array.from({ length: this.width }, () => new Array(this.height));
    let tempCM = Array.from({ length: this.width }, () => Array.from({ length: this.height }, () => []));

    for (let x = 0; x < this.width; x++) {
      for (let y = 0; y < this.height; y++) {
        tempCM[x][y] = this.calibrationMatrix[this.width - x - 1][this.height - 1 - y];
        tempIM[x][y] = this.interpolationMatrix[this.width - x - 1][this.height - 1 - y];
      }
    }
    this.calibrationMatrix = tempCM;
    this.interpolationMatrix = tempIM;
    const temp = this.width;
    this.width = this.height;
    this.height = temp;
  }

  calibrate(rawImage) {
    if (rawImage === null || rawImage === undefined) return;

    let calibrated = new Mat(rawImage.rows, rawImage.cols, rawImage.type());
    subtract(rawImage, this.zeroFrame, calibrated);
    // this.printMatToConsole(rawImage);

    const fw = calibrated.cols;
    const fh = calibrated.rows;
    for (let x = 0; x < fw; x++) {
      for (let y = 0; y < fh; y++) {
        let fdata = calibrated.ushortPtr(y, x)[0];
        if (fdata < 0) fdata = 0;
        //let regresssor  = new LinearSpline(this.interpolationMatrix[x][y]);
        let calibratedValue = parseInt(this.interpolationMatrix[x][y].predict(fdata)); //convert float to int
        if (calibratedValue < 0) calibratedValue = 0;
        if (calibratedValue > 850) calibratedValue = 850;
        calibrated.ushortPtr(y, x)[0] = calibratedValue;
      }
    }
    // this.printMatToConsole(calibrated);
    return calibrated;
  }

  async exportImageAsFile(mat, filename = "image.png") {
    // 1. Create a temporary canvas element.
    const canvas = document.createElement('canvas');

    // 2. Display the Mat on the canvas.
    // This automatically handles the conversion of pixel data.
    imshow(canvas, mat);

    // 3. Convert the canvas content to a Blob.
    // The toBlob() method is asynchronous.
    canvas.toBlob((blob) => {
      if (blob) {
        // 4. Create a temporary URL for the Blob.
        const url = URL.createObjectURL(blob);

        // 5. Create and click a temporary download link.
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();

        // 6. Clean up the temporary URL and link.
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } else {
        console.error('Failed to create a Blob from the canvas.');
      }
    }, 'image/png'); // Specify the desired format
  }

  checkNonZero(img) {
    const fw = img.cols;
    const fh = img.rows;
    for (let x = 0; x < fw; x++) {
      for (let y = 0; y < fh; y++) {
        const fdata = img.ushortPtr(y, x)[0];
        if (fdata !== 0) {
          console.warn("Non zero value found in the image");
          return true;
        }
      }
    }
    return false;
  }

  printMatToConsole(mat) {
    const fw = mat.cols;
    const fh = mat.rows;
    let result = "";
    for (let x = 0; x < fw; x++) {
      for (let y = 0; y < fh; y++) {
        result += mat.ushortPtr(y, x)[0] + " ";
      }
      result += "\n";
    }
    console.log(result);
  }
}